import LegalPage from "@/components/LegalPage";
import { CONTACT_EMAIL } from "@/lib/config";

export default function Refunds() {
    return (
        <LegalPage
            testId="refunds-page"
            eyebrow="Legal"
            title="Refund & Cancellation Policy"
            updated="June 2026"
            seoTitle="Refund & Cancellation Policy · Abhijit J K"
            seoDescription="Refund, cancellation, and rescheduling policy for paid consultations with Abhijit J K, Founder of Ragi Media."
            intro="This policy explains how cancellations, rescheduling, and refunds work for paid consultations booked through this website."
            sections={[
                {
                    heading: "Rescheduling",
                    body: "If you are unable to attend your scheduled consultation, you may reschedule once at no extra cost, provided you request the change at least 24 hours before the scheduled start time. Rescheduling can be requested by email or WhatsApp.",
                },
                {
                    heading: "Cancellations & Refunds",
                    list: [
                        "Cancellations requested at least 24 hours before the scheduled session are eligible for a full refund.",
                        "Cancellations requested within 24 hours of the session may be eligible for a partial refund or a one-time reschedule, at our discretion.",
                        "No-shows (failing to attend the scheduled session without prior notice) are not eligible for a refund.",
                    ],
                },
                {
                    heading: "How Refunds Are Processed",
                    body: "Approved refunds are processed to your original payment method via Razorpay within 5–7 business days. The exact time to reflect in your account depends on your bank or payment provider.",
                },
                {
                    heading: "How to Request a Refund or Reschedule",
                    body: `To request a refund or reschedule, email us at ${CONTACT_EMAIL} with your name, booking details, and the date of your session.`,
                },
                {
                    heading: "Service Not Delivered",
                    body: "In the rare event that a consultation cannot be delivered from our side (for example, due to an emergency), you will be offered a full refund or a rescheduled session at your preference.",
                },
                {
                    heading: "Contact",
                    body: `For any questions about refunds or cancellations, contact us at ${CONTACT_EMAIL}.`,
                },
            ]}
        />
    );
}
